// extracted by css-extract-rspack-plugin
export default {"root":"Kw4_5h"};